import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../Redux/Store";
import Layout from "../Screens/Common/Layout/Layout";
import Dashboard from "../Screens/Admin/Dashboard";
import Businesses from "../Screens/Admin/Businesses";
import Venues from "../Screens/Admin/VenueManager/Venues";
import VanueUpdate from "../Screens/Admin/VenueManager/VenueUpdate";
import VenueDetails from "../Screens/Admin/VenueManager/venuesDetails";
import VenueMediaReports from "../Screens/Admin/VenueManager/VenueTab/VenueMediaReports";
import Days from "../Screens/Admin/Manage/Days/Days";
import ListAvtars from "../Screens/Admin/Manage/LoucaAvtars/listAvtar";
import LoucaAi from "../Screens/Admin/Manage/LoucaAi/LoucaAi";
import RatingQuestion from "../Screens/Admin/Manage/RatingQuestion/RatingQuestion";
import UserManagement from "../Screens/Admin/UserManagement/Role/user";
import AdminManagement from "../Screens/Admin/UserManagement/Role/admin";
import OwnerManagement from "../Screens/Admin/UserManagement/Role/venueOwner";
import UserDetails from "../Screens/Admin/UserManagement/userDetails";
import AddUserPage from "../Screens/Admin/UserManagement/addUser";
import PublicUser from "../Screens/Admin/UserManagement/Role/publicUser";
import Login from "../Screens/Admin/Login/Login";
import ForgetPage from "../Screens/Admin/Login/forgotPassword";
import { ToastContainer } from "react-toastify";
import CurrentKids from "../Screens/Admin/ManageDating/CurrentKids/CurrentKids";
import Drinking from "../Screens/Admin/ManageDating/Drinking/Drinking";
import FutureKids from "../Screens/Admin/ManageDating/FutureKids/FutureKids";
import Smoking from "../Screens/Admin/ManageDating/Smoking/Smoking";
import Qualities from "../Screens/Admin/ManageDating/Qualities/Qualities";
import Hobbies from "../Screens/Admin/ManageDating/Hobbies/Hobbies";
import Relationship from "../Screens/Admin/ManageDating/Relationship/Relationship";
import Education from "../Screens/Admin/ManageDating/Education/Education";
import Gender from "../Screens/Admin/ManageDating/Gender/Gender";
import DatExercise from "../Screens/Admin/ManageDating/Exercise/Exercise";
import Unrecognized from "../Screens/Admin/Unrecognized/Unrecognized";
import LoucaCoins from "../Screens/Admin/LoucaCoins/LoucaCoins";
import VenueOwnerDetails from "../Screens/Admin/UserManagement/venueOwnerDetails";
import MediaReason from "../Screens/Admin/MediaReason/MediaReason";
import VenueSaveReason from "../Screens/Admin/VenueSaveReason/VenueSaveReason";
import QuickSurveyCategory from "../Screens/Admin/Manage/QuickSurveyQus/QuickSurveyCategory";
import QuickSurveyQuestions from "../Screens/Admin/Manage/QuickSurveyQus/QuickSurveyQuestions";
import Analytics from "../Screens/Admin/Analytics/Analytics";
import ProfileType from "../Screens/Admin/Manage/Profile Types/ProfileTypes";
import EventType from "../Screens/Admin/Manage/Event/eventTypes";
import PublicUserDetails from "../Screens/Admin/UserManagement/publicUserDetails"
import Pronouns from "../Screens/Admin/ManageDating/Pronouns/Pronouns";
import Occupations from "../Screens/Admin/ManageDating/Occupations/Occupations";
import DatingAgeGroup from "../Screens/Admin/ManageDating/DatingAgeGroup/DatingAgeGroup";
import HairColor from "../Screens/Admin/ManageDating/HairColor/HairColor";
import Height from "../Screens/Admin/ManageDating/Height/Height";
import BodyType from "../Screens/Admin/ManageDating/BodyType/BodyType";
import LegalContent from "../Screens/Admin/LegalContent/LegalContent";
import AgeGroup from "../Screens/Admin/Manage/AgeGroups/AgeGroups";
import Alcohol from "../Screens/Admin/Manage/Alcohol/Alcohol";
import Cravings from "../Screens/Admin/Manage/Cravings/Cravings";
import Crowds from "../Screens/Admin/Manage/Crowd/Crowd";
import Cuisine from "../Screens/Admin/Manage/Cuisine/Cuisine";
import Dietary from "../Screens/Admin/Manage/Dietary/Dietary";
import DJClubs from "../Screens/Admin/Manage/DJClubs/DJClubs";
import EntryFee from "../Screens/Admin/Manage/EntryFee/EntryFee";
import EventActivities from "../Screens/Admin/Manage/EventActivities/EventActivities";
import FoodPrice from "../Screens/Admin/Manage/FoodPrice/FoodPrice";
import LiveMusic from "../Screens/Admin/Manage/LiveMusic/LiveMusic";
import NonAlcohol from "../Screens/Admin/Manage/NonAlcohol/NonAlcohol";
import Regions from "../Screens/Admin/Manage/Regions/Regions";
import Specials from "../Screens/Admin/Manage/Specials/Specials";
import VenueTags from "../Screens/Admin/Manage/VenueTag/VenueTag";
import IntrestedIn from "../Screens/Admin/Manage/IntrestedIn/IntrestedIn";
import RelationShipStatus from "../Screens/Admin/Manage/RelationShipStatus/RelationShipStatus";
import Register from "../Screens/VenueOwner/Register/Register";
import VenuesOwners from "../Screens/VenueOwner/Venues/VenuesOwners";
import NightPrefrence from "../Screens/Admin/ManageDating/Night Prefrence/NightPrefrence";


function AppRoutes() {
  const token = useSelector((state: RootState) => state.global.token);

  return (
    <div>
      {token ? (
        <Routes>
          <Route path="*" element={<Navigate to="/admin/Dashboard" />} />
          <Route path="/admin/Dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/admin/businesses" element={<Layout><Businesses /></Layout>} />
          <Route path="/admin/venues" element={<Layout><Venues /></Layout>} />
          <Route path="/admin/venue-owner" element={<Layout><VenuesOwners /></Layout>} />
          <Route path="/admin/venueUpdate" element={<Layout><VanueUpdate /></Layout>} />
          <Route path="/admin/add-venue" element={<Layout><VanueUpdate /></Layout>} />
          <Route path="/admin/VenueDetails" element={<Layout><VenueDetails /></Layout>} />
          <Route path="/admin/VenueMediaReports" element={<Layout><VenueMediaReports /></Layout>} />
          <Route path="/admin/Days" element={<Layout><Days /></Layout>} />
          <Route path="/admin/Alcohol" element={<Layout><Alcohol /></Layout>} />
          <Route path="/admin/IntrestedIn" element={<Layout><IntrestedIn /></Layout>} />
          <Route path="/admin/Crowds" element={<Layout><Crowds /></Layout>} />
          <Route path="/admin/RelationShipStatus" element={<Layout><RelationShipStatus /></Layout>} />
          <Route path="/admin/Cuisine" element={<Layout><Cuisine /></Layout>} />
          <Route path="/admin/Cravings" element={<Layout><Cravings /></Layout>} />
          <Route path="/admin/DJClubs" element={<Layout><DJClubs /></Layout>} />
          <Route path="/admin/NonAlcohol" element={<Layout><NonAlcohol /></Layout>} />
          <Route path="/admin/Regions" element={<Layout><Regions /></Layout>} />
          <Route path="/admin/Specials" element={<Layout><Specials /></Layout>} />
          <Route path="/admin/VenueTags" element={<Layout><VenueTags /></Layout>} />
          <Route path="/admin/EntryFee" element={<Layout><EntryFee /></Layout>} />
          <Route path="/admin/EventActivities" element={<Layout><EventActivities /></Layout>} />
          <Route path="/admin/FoodPrice" element={<Layout><FoodPrice /></Layout>} />
          <Route path="/admin/LiveMusic" element={<Layout><LiveMusic /></Layout>} />
          <Route path="/admin/Dietary" element={<Layout><Dietary /></Layout>} />
          <Route path="/admin/LoucaAvtars" element={<Layout><ListAvtars /></Layout>} />
          <Route path="/admin/LoucaAi" element={<Layout><LoucaAi /></Layout>} />
          <Route path="/admin/RatingQuestion" element={<Layout><RatingQuestion /></Layout>} />
          <Route path="/admin/QuickSurveyCategory" element={<Layout><QuickSurveyCategory /></Layout>} />
          <Route path="/admin/QuickSurveyQuestions" element={<Layout><QuickSurveyQuestions
          /></Layout>} />
          <Route path="/admin/current-kids" element={<Layout><CurrentKids /></Layout>} />
          <Route path="/admin/pronouns" element={<Layout><Pronouns /></Layout>} />
          <Route path="/admin/DatingAgeGroup" element={<Layout><DatingAgeGroup /></Layout>} />
          <Route path="/admin/hairColor" element={<Layout><HairColor /></Layout>} />
          <Route path="/admin/height" element={<Layout><Height /></Layout>} />
          <Route path="/admin/bodyType" element={<Layout><BodyType /></Layout>} />
          <Route path="/admin/occupations" element={<Layout><Occupations /></Layout>} />
          <Route path="/admin/drinking" element={<Layout><Drinking /></Layout>} />
          <Route path="/admin/future-Kids" element={<Layout><FutureKids /></Layout>} />
          <Route path="/admin/smoking" element={<Layout><Smoking /></Layout>} />
          <Route path="/admin/AgeGroup" element={<Layout><AgeGroup /></Layout>} />
          <Route path="/admin/qualities" element={<Layout><Qualities /></Layout>} />
          <Route path="/admin/hobbies" element={<Layout><Hobbies /></Layout>} />
          <Route path="/admin/night-Preference" element={<Layout><NightPrefrence /></Layout>} />
          <Route path="/admin/Relationship" element={<Layout><Relationship /></Layout>} />
          <Route path="/admin/education" element={<Layout><Education /></Layout>} />
          <Route path="/admin/gender" element={<Layout><Gender /></Layout>} />
          <Route path="/admin/exercises" element={<Layout><DatExercise /></Layout>} />
          <Route path="/admin/User" element={<Layout><UserManagement /></Layout>} />
          <Route path="/admin/publicUser" element={<Layout><PublicUser /></Layout>} />
          <Route path="/admin/Admin" element={<Layout><AdminManagement /></Layout>} />
          <Route path="/admin/VenueOwner" element={<Layout><OwnerManagement /></Layout>} />
          <Route path="/admin/UserDetails" element={<Layout><UserDetails /></Layout>} />
          <Route path="/admin/PublicUserDetails" element={<Layout><PublicUserDetails /></Layout>} />
          <Route path="/admin/VenueOwnerDetails" element={<Layout><VenueOwnerDetails /></Layout>} />
          <Route path="/admin/AddUser" element={<Layout><AddUserPage /></Layout>} />
          <Route path="/admin/unrecognized" element={<Layout><Unrecognized /></Layout>} />
          <Route path="/admin/LegalContent" element={<Layout><LegalContent /></Layout>} />
          <Route path="/admin/LoucaCoins" element={<Layout><LoucaCoins /></Layout>} />
          <Route path="/admin/Analytics" element={<Layout><Analytics /></Layout>} />
          <Route path="/admin/MediaReason" element={<Layout><MediaReason /></Layout>} />
          <Route path="/admin/VenueSaveReason" element={<Layout><VenueSaveReason /></Layout>} />
          <Route path="/admin/ProfileType" element={<Layout><ProfileType /></Layout>} />
          <Route path="/admin/EventType" element={<Layout><EventType /></Layout>} />



        </Routes>
      ) : (
        <Routes>
          <Route path="/admin/login" element={<Login />} />
          <Route path="/venue-owner/register" element={<Register />} />
          <Route path="/admin/ForgotPassword" element={<ForgetPage />} />
          <Route path="*" element={<Navigate to="/admin/login" />} />
        </Routes>
      )}

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
        closeButton={false}
      />

    </div>
  );
}

export default AppRoutes;
